import axios from "axios"
import Consts from "../app/consts"

export default class SiteService {
  static getAll() {
    return axios.get(Consts.BASE_API_URL + "/api/sites")
  }
}
